export default {
  modules: {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'indent': '-1' }, { 'indent': '+1' }],
        [{ 'size': ['small', false, 'large', 'huge'] }],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'color': [] }, { 'background': [], 'font': [] }],
        [{ 'align': '' }, { 'align': 'center' }, { 'align': 'right' }]
      ]
    }
  },
  theme: 'snow'
}



// WEBPACK FOOTER //
// ./src/editor/index.js